import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { VideoOverviewResponse } from '~client/model/video-overview-response';
import { DataGroupingType } from '~client/model/data-grouping-type';
import { Granularity } from '~client/model/granularity';
import { VideoTimeseriesResponse } from '~client/model/video-timeseries-response';

export class VideoAnalyticsController extends BaseController {
  /* Fetch video analytics summary details for whole event */
  public getOverview$(eventId: number): Observable<VideoOverviewResponse> {
    return this.get$('/videoAnalytics/fetchOverview', { eventId });
  }

  /* Fetch video analytics timeline for whole event */
  public getTimeline$(
    eventId: number,
    dataGrouping: DataGroupingType,
  ): Observable<VideoTimeseriesResponse> {
    return this.get$('/videoAnalytics/fetchVideoTimeseries', {
      eventId,
      dataGrouping,
      granularity: Granularity.MINUTE,
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/video-analytics-controller.ts